import { GTM_EVENT_NAMES } from '@/constants/app.constants';
import type { _GTMEventValues, GTMEventValues } from './gtm';
import { _pushGTMEvent, pushGTMEvent } from './gtm';
import type { TechnologyShortCode } from '@/services/apis/getServiceQualification/schemas';
import type { GTMSelectItem } from './types';
import type { CTAGtmMetaType } from '@/components/cms/schemas';

export const gtmHeaderLogoClick = (values: { clickUrl: string }) => {
  pushGTMEvent(GTM_EVENT_NAMES.headerLogoClick, values);
};

export const gtmNavClick = (values: {
  clickUrl: string;
  clickText: string;
  navType: 'Primary Nav Menu' | 'Footer Nav Menu';
}) => {
  pushGTMEvent(GTM_EVENT_NAMES.navClick, values);
};

export const gtmSocialClick = (values: {
  clickUrl: string;
  clickText: string;
}) => {
  pushGTMEvent(GTM_EVENT_NAMES.socialClick, values);
};

export const gtmOnAddressSubmit = (values: {
  userPostcode: string;
  userState: string;
}) => {
  const gtmValues = {
    ...values,
    pageCategory: 'RESIDENTIAL',
  };
  pushGTMEvent(GTM_EVENT_NAMES.sqAddressSubmitResi, gtmValues);
};

export const gtmSQSubmitSuccessResi = (values: {
  technologyType?: TechnologyShortCode | null;
  userPostcode: string;
  userState: string;
  onePlanAvailability: 'True' | 'False';
}) => {
  pushGTMEvent(GTM_EVENT_NAMES.sqSubmitSuccessResi, values);
};

export const gtmSQAddressNotAvailable = (values: {
  userPostcode: string;
  userState: string;
}) => {
  const gtmValues = {
    ...values,
    addressOutcome: 'Service not available',
  };
  pushGTMEvent(GTM_EVENT_NAMES.sqAddressNotAvailable, gtmValues);
};

export const gtmFindAddressClick = () => {
  pushGTMEvent(GTM_EVENT_NAMES.findAddressClick);
};

export const gtmSQSubmitExistingUser = (values: {
  userPostcode: string;
  userState: string;
}) => {
  const gtmValues = {
    ...values,
    addressOutcome: 'Existing Users',
  };
  pushGTMEvent(GTM_EVENT_NAMES.sqSubmitExistingUser, gtmValues);
};

export const gtmCTAClickSQ = (values: {
  clickText: string;
  clickUrl?: string;
}) => {
  const url = window.location.href;
  const gtmValues = {
    ...values,
    clickUrl: values.clickUrl ?? url,
  };
  pushGTMEvent(GTM_EVENT_NAMES.ctaClickSq, gtmValues);
};

export const gtmCTaClick = (values: { clickText: string }) => {
  const url = window.location.href;
  const gtmValues = {
    clickUrl: url,
    ...values,
  };
  pushGTMEvent(GTM_EVENT_NAMES.ctaClick, gtmValues);
};

export const gtmCTAClickSQBanner = (values: {
  clickText: string;
  clickUrl?: string;
}) => {
  const url = window.location.href;
  const gtmValues = {
    ...values,
    clickUrl: values.clickUrl ?? url,
  };
  pushGTMEvent(GTM_EVENT_NAMES.ctaClickSqBanner, gtmValues);
};

export const gtmSelectItem = (values: GTMSelectItem) => {
  pushGTMEvent(
    GTM_EVENT_NAMES.selectItem,
    values as unknown as GTMEventValues,
    true
  );
};

export const gtmMobilePlanCardSelect = (values: {
  planName: string;
  totalPrice: number;
}) => {
  pushGTMEvent(GTM_EVENT_NAMES.mobilePlanCardSelect, values);
};

export const gtmNBNPlanCardSelect = (values: {
  planName: string;
  totalPrice: number;
}) => {
  pushGTMEvent(GTM_EVENT_NAMES.nbnPlanCardSelect, values);
};

export const gtmAppDownloadClick = (values: {
  appType: 'iOS' | 'Android';
  clickText: string;
  clickUrl: string;
}) => {
  pushGTMEvent(GTM_EVENT_NAMES.appDownloadClick, values);
};

export const gtmKnowledgeHubLink = (values: {
  clickText: string;
  clickUrl: string;
}) => {
  values.clickUrl = `${window.location.origin}${values.clickUrl}`;
  pushGTMEvent(GTM_EVENT_NAMES.knowledgeHubLink, values);
};

type ParseGTMlValues = Record<string, string | Record<string, string | null>>;
const parseGTMValues = (obj: ParseGTMlValues) => {
  if (!obj) return {};
  const newObj: _GTMEventValues = {};
  for (const key in obj) {
    if (!obj[key]) {
      continue;
    }
    newObj[key] =
      typeof obj[key] === 'object'
        ? parseGTMValues(obj[key] as Record<string, string>)
        : obj[key];
  }

  return newObj;
};

export const gtmCMSCta = (values: CTAGtmMetaType) => {
  const gtmValues = parseGTMValues(values as ParseGTMlValues);
  _pushGTMEvent(gtmValues);
};
